<template>
  <div id="contenedor-eliminar-auditoria-informe-respuesta">
    <v-card>
      <v-card-title class="secondary--text"> Eliminar Respuesta </v-card-title>
      <v-card-text>
        <span class="secondary--text"> ¿Desea eliminar la Respuesta? </span>
        <v-divider></v-divider>
        <v-row>
          <span class="font-weight-bold">
            {{respuesta.numeroOficio}}
          </span>
        </v-row>
        <v-row>
          <span> <cortar-texto
          :texto="respuesta.comentarios? respuesta.comentarios : ''">
          </cortar-texto>
          </span>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button
          @click="cerrar"
          tipo="formCancelar"
          label="Cancelar"
          class="mr-3"
        >
        </custom-button>
        <custom-button
          @click="botonEliminarAuditoriaInformeRespuesta"
          :disabled="enviandoFormulario || tieneDependencias || $apollo.loading"
          :loading="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar"
        >
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
import mixRespuestas from './mixRespuestas';
import CustomButton from '@/components/buttons/Button.vue';
import CortarTexto from '@/components/CortarTextos.vue';

export default {
  name: 'EliminarAuditoriaInformeRespuesta',
  props: {
    respuesta: {
      type: Object,
      required: true,
    },
  },
  mixins: [mixRespuestas],
  components: {
    CustomButton,
    CortarTexto,
  },
  data() {
    return {
      enviandoFormulario: false,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
    botonEliminarAuditoriaInformeRespuesta() {
      this.enviandoFormulario = true;
      this.mixEliminarRespuesta();
    },
  },
  computed: {
    tieneDependencias() {
      return this.respuesta.detalles.length > 0;
    },
  },
};
</script>
